import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  currentBrandSelector,
  isEnterpriseContextSelector,
  isBrandFilterableSelector,
  isWhiteListedForCampaignSelector,
} from 'store/global/selectors';
import EnterpriseMain from 'containers/Main/EnterpriseMain';
import BrandMain from 'containers/Main/BrandMain';
import BrandFilteringStatusLoader from 'components/BrandFilteringStatusLoader';
import { ROUTES } from 'utils/routes';
import * as globalActions from 'store/global/actions';
import FeatureToggle from 'utils/feature-toggle-utils';

const Main = () => {
  const dispatch = useDispatch();
  const isEnterpriseContext: boolean = useSelector(isEnterpriseContextSelector);
  const currentBrand: string = useSelector(currentBrandSelector);
  const isBrandFilterable: boolean = useSelector(isBrandFilterableSelector);
  const isWhiteListedForCampaign: boolean = useSelector(isWhiteListedForCampaignSelector);

  if (isEnterpriseContext && FeatureToggle.isFeatureEnabled(FeatureToggle.FEATURES.PORTFOLIO)) {
    if (!currentBrand) {
      return <EnterpriseMain />;
    } else {
      return (
        <BrandFilteringStatusLoader currentBrand={currentBrand}>
          <BrandMain
            navigationLinks={Object.entries(ROUTES)
              .filter((value) => {
                const disabledRoutes = [ROUTES.SCORECARDS];
                if (!isWhiteListedForCampaign) {
                  disabledRoutes.push(ROUTES.CAMPAIGNS);
                }
                if (!isBrandFilterable) {
                  disabledRoutes.push(ROUTES.CAMPAIGNS);
                  disabledRoutes.push(ROUTES.GROUPS);
                }
                return !disabledRoutes.includes(value[1]);
              })
              .map((value) => {
                const result = {
                  route: value[1],
                  label: value[0].toLowerCase(),
                };
                if (value[1] === ROUTES.PORTFOLIO) {
                  return {
                    ...result,
                    onSelect: () => dispatch(globalActions.setCurrentBrand('')),
                  };
                }
                return result;
              })}
          />
        </BrandFilteringStatusLoader>
      );
    }
  } else {
    return (
      <BrandMain
        navigationLinks={Object.entries(ROUTES)
          .filter((value) =>
            !isWhiteListedForCampaign
              ? value[1] !== ROUTES.CAMPAIGNS && value[1] !== ROUTES.PORTFOLIO
              : value[1] !== ROUTES.PORTFOLIO
          )
          .map((value) => ({
            route: value[1],
            label: value[0].toLowerCase(),
          }))}
      />
    );
  }
};

export default Main;
